import { FunctionComponent, ReactNode } from 'react';

type Props = {
  middlewares: FunctionComponent[];
  children: ReactNode;
};

export default function Compose(props: Props) {
  const { middlewares, children } = props;

  if (!middlewares || middlewares.length === 0) return children;

  return (
    <>
      {middlewares?.reduceRight(
        (Accumulator, CurrentComponent) => (
          <CurrentComponent>{Accumulator}</CurrentComponent>
        ),
        children
      )}
    </>
  );
}
